module.exports = __webpack_public_path__ + "static/media/carnera_logo.6df2f6e1.png";